import { SessionMessage } from '../../session-message/session-message';

export function getSessionSummaryPrompt(sessionMessageList: SessionMessage[]) {
  let chatHistory = '';

  sessionMessageList.forEach((message) => {
    chatHistory += `Sales Rep: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `Given the conversation history below between "Customer" and a "Sales Rep", identify key points that demonstrate seller’s communication technique. Identify top one points that the sellers did best or did worst. Be brief and concise.
Output one short paragraph as the summary of this conversation, focusing on accessing Seller's performance. The length should be up to 80 words. In your output, you are talking to the sales rep in the conversation history. You are giving advice to the audience referred as "You".

<CHAT_HISTORY>
${chatHistory}
</CHAT_HISTORY>
`;
}
